export const acodeConfig = {
    adRequestSend: 10216, // 广告数据请求发出
    adRequestComplete: 9910, // 广告数据请求完成
    activityEntryClick: 10651, // 焦点底部活动入口点击
    activityEntryExpose: 10652, // 焦点底部活动入口曝光
    shareAction: 3032, // 分享行为上报
    cancelShare: 10084, // 分享取消
    shareCLick: 3031, // 底部分享按钮点击
    topNavExpandClick: 10082, // 顶部展开全站导航按钮点击
    floatPanelNavClick: 10083,// 悬浮面板导航点击
    clickLikeButton: 9141, // 点击点赞按钮
    checkAllComments: 10923, // 外置评论轮播组件-全部评论查看
    clickImgUpload: 10947, // 点击图片上传按钮
    imgUpload: 11058, // 图片上传
    commentSubmit: 3559, // 评论提交
}